import type { Locale } from '../type';

const localeValues: Locale = {
  locale: 'es',
  Pagination: {
    items_per_page: '/ página',
    jump_to: 'Ir a',
    jump_to_confirm: 'confirmar',
    page: '',
    prev_page: 'Página anterior',
    next_page: 'Página siguiente',
    prev_5: '5 páginas previas',
    next_5: '5 páginas siguientes',
    prev_3: '3 páginas previas',
    next_3: '3 páginas siguientes',
  },
  DatePicker: {
    lang: {
      placeholder: 'Seleccionar fecha',
      rangePlaceholder: [
        'Fecha inicial',
        'Fecha final',
      ],
      locale: 'es_ES',
      today: 'Hoy',
      now: 'Ahora',
      backToToday: 'Volver a hoy',
      ok: 'Aceptar',
      clear: 'Limpiar',
      month: 'Mes',
      year: 'Año',
      timeSelect: 'Seleccionar hora',
      dateSelect: 'Seleccionar fecha',
      monthSelect: 'Elegir un mes',
      yearSelect: 'Elegir un año',
      decadeSelect: 'Elegir una década',
      yearFormat: 'YYYY',
      dateFormat: 'D/M/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D/M/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Mes anterior (PageUp)',
      nextMonth: 'Mes siguiente (PageDown)',
      previousYear: 'Año anterior (Control + left)',
      nextYear: 'Año siguiente (Control + right)',
      previousDecade: 'Década anterior',
      nextDecade: 'Década siguiente',
      previousCentury: 'Siglo anterior',
      nextCentury: 'Siglo siguiente',
    },
    timePickerLocale: {
      placeholder: 'Seleccionar hora',
    },
  },
  TimePicker: {
    placeholder: 'Seleccionar hora',
  },
  Calendar: {
    lang: {
      placeholder: 'Seleccionar fecha',
      rangePlaceholder: [
        'Fecha inicial',
        'Fecha final',
      ],
      locale: 'es_ES',
      today: 'Hoy',
      now: 'Ahora',
      backToToday: 'Volver a hoy',
      ok: 'Aceptar',
      clear: 'Limpiar',
      month: 'Mes',
      year: 'Año',
      timeSelect: 'Seleccionar hora',
      dateSelect: 'Seleccionar fecha',
      monthSelect: 'Elegir un mes',
      yearSelect: 'Elegir un año',
      decadeSelect: 'Elegir una década',
      yearFormat: 'YYYY',
      dateFormat: 'D/M/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D/M/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Mes anterior (PageUp)',
      nextMonth: 'Mes siguiente (PageDown)',
      previousYear: 'Año anterior (Control + left)',
      nextYear: 'Año siguiente (Control + right)',
      previousDecade: 'Década anterior',
      nextDecade: 'Década siguiente',
      previousCentury: 'Siglo anterior',
      nextCentury: 'Siglo siguiente',
    },
    timePickerLocale: {
      placeholder: 'Seleccionar hora',
    },
  },
  global: {
    placeholder: 'Seleccione',
  },
  Table: {
    filterTitle: 'Filtrar menú',
    filterConfirm: 'Aceptar',
    filterReset: 'Reiniciar',
    filterEmptyText: 'Sin filtros',
    emptyText: 'Sin datos',
    selectAll: 'Seleccionar todo',
    selectInvert: 'Invertir selección',
    selectNone: 'Vacíe todo',
    selectionAll: 'Seleccionar todos los datos',
    sortTitle: 'Ordenar',
    expand: 'Expandir fila',
    collapse: 'Colapsar fila',
    triggerDesc: 'Click para ordenar en orden descendente',
    triggerAsc: 'Click para ordenar en orden ascendente',
    cancelSort: 'Click para cancelar ordenamiento',
  },
  Modal: {
    okText: 'Aceptar',
    cancelText: 'Cancelar',
    justOkText: 'Aceptar',
  },
  Popconfirm: {
    okText: 'Aceptar',
    cancelText: 'Cancelar',
  },
  Transfer: {
    titles: [
      '',
      '',
    ],
    searchPlaceholder: 'Buscar aquí',
    itemUnit: 'elemento',
    itemsUnit: 'elementos',
    remove: 'Eliminar',
    selectCurrent: 'Seleccionar página actual',
    removeCurrent: 'Remover página actual',
    selectAll: 'Seleccionar todos los datos',
    removeAll: 'Eliminar todos los datos',
    selectInvert: 'Invertir página actual',
  },
  Upload: {
    uploading: 'Subiendo...',
    removeFile: 'Eliminar archivo',
    uploadError: 'Error al subir el archivo',
    previewFile: 'Vista previa',
    downloadFile: 'Descargar archivo',
  },
  Empty: {
    description: 'No hay datos',
  },
  Icon: {
    icon: 'ícono',
  },
  Text: {
    edit: 'Editar',
    copy: 'Copiar',
    copied: 'Copiado',
    expand: 'Expandir',
  },
  PageHeader: {
    back: 'Volver',
  },
  Form: {
    optional: '(opcional)',
    defaultValidateMessages: {
      default: 'Error de validación del campo ${label}',
      required: 'Por favor ingresar ${label}',
      enum: '${label} debe ser uno de [${enum}]',
      whitespace: '${label} no puede ser un carácter en blanco',
      date: {
        format: 'El formato de fecha de ${label} es inválido',
        parse: '${label} no se puede convertir a una fecha',
        invalid: '${label} es una fecha inválida',
      },
      types: {
        string: '${label} no es un ${type} válido',
        method: '${label} no es un ${type} válido',
        array: '${label} no es un ${type} válido',
        object: '${label} no es un ${type} válido',
        number: '${label} no es un ${type} válido',
        date: '${label} no es un ${type} válido',
        boolean: '${label} no es un ${type} válido',
        integer: '${label} no es un ${type} válido',
        float: '${label} no es un ${type} válido',
        regexp: '${label} no es un ${type} válido',
        email: '${label} no es un ${type} válido',
        url: '${label} no es un ${type} válido',
        hex: '${label} no es un ${type} válido',
      },
      string: {
        len: '${label} debe tener ${len} caracteres',
        min: '${label} debe tener al menos ${min} caracteres',
        max: '${label} debe tener hasta ${max} caracteres',
        range: '${label} debe tener entre ${min}-${max} caracteres',
      },
      number: {
        len: '${label} debe ser igual a ${len}',
        min: '${label} valor mínimo es ${min}',
        max: '${label} valor máximo es ${max}',
        range: '${label} debe estar entre ${min}-${max}',
      },
      array: {
        len: 'Debe ser ${len} ${label}',
        min: 'Al menos ${min} ${label}',
        max: 'A lo mucho ${max} ${label}',
        range: 'El monto de ${label} debe estar entre ${min}-${max}',
      },
      pattern: {
        mismatch: '${label} no coincide con el patrón ${pattern}',
      },
    },
  },
  Image: {
    preview: 'Previsualización',
  },
};

export default localeValues;
